import React from 'react';
import { SEOTableData, TableConfig } from 'src/api/models/SEOTable';
import { BodyContainer } from './Body.styles';
import Row from './Row';

type BodyProps = Pick<SEOTableData, 'table'> & TableConfig;

const Body = ({ table, ...rest }: BodyProps): JSX.Element => {
  return (
    <BodyContainer>
      {table.map((row, index) => (
        <Row
          key={index}
          index={index + 1}
          {...row}
          {...rest}
        />
      ))}
    </BodyContainer>
  );
};

export default Body;
